import React from "react"
import {
  Box,
  Container,
  Divider,
  Typography,
  makeStyles,
} from "@material-ui/core"
import Layout from "../components/layout"
import SEO from "../components/seo"
import LeadForm from "../components/forms/LeadForm"
import Featured from "../components/ui/Featured"
import titleImage from "../images/TitleImage.png"
import geneenPhoto from "../images/geneen_group.jpg"

import geneenIllustration from "../images/Geneen_illustrations.jpg"
import OfferFooter from "../components/ui/OfferFooter"

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: "center",
  },
  h1: {
    fontWeight: 500,
    lineHeight: 0.9,
    [theme.breakpoints.down("sm")]: {
      fontSize: "3rem",
      textAlign: "center",
    },
  },
  h4: {
    fontWeight: 600,
    color: "#3aa68c",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  badge: {
    padding: theme.spacing(1),
    background: "black",
    width: 140,
    color: "white",
    borderRadius: 5,
    textAlign: "center",
    margin: "auto",
  },
  space: {
    marginTop: theme.spacing(4),
  },
}))

const IndexPage = () => {
  const classes = useStyles()

  return (
    <>
      <Layout>
        <SEO />
        <Container>
          <Box
            display="flex"
            p={1}
            m={1}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box p={1} mr={3} mt={5} width={{ xs: "100%", md: "42%" }}>
              <img
                src={titleImage}
                alt="Geneen Roth"
                className={classes.aboutImage}
                style={{ width: "100%" }}
              />
            </Box>
            <Box p={1} width={{ xs: "100%", md: "58%" }}>
              <div className={classes.badge}>
                <Typography variant="overline" style={{ fontWeight: 700 }}>
                  FREE AUDIO
                </Typography>
              </div>
              <Box
                display={{ xs: "block", sm: "block", md: "none" }}
                m={2}
              ></Box>

              <Typography variant="h1" gutterBottom className={classes.h1}>
                Discover what you really want.
              </Typography>

              <Typography variant="h4" gutterBottom className={classes.h4}>
                Hint: It’s not food.
              </Typography>
              <Typography variant="body1" gutterBottom className={classes.body}>
                Join author Geneen Roth and receive EXCLUSIVE access to a
                60-minute talk from her live retreat. Discover why we
                unconsciously keep the weight challenge alive and continue to
                eat what doesn’t feel good.{" "}
                <span style={{ fontWeight: 600 }}>
                  Allow yourself freedom with food and the peace you’ve been
                  looking for.
                </span>
              </Typography>
              <div className={classes.space}></div>
              <LeadForm />
            </Box>
          </Box>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="overline">As Seen On </Typography>
          </div>

          <Divider />
          <Featured />

          <Box
            display="flex"
            p={1}
            m={1}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box p={1} width={{ xs: "100%", md: "58%" }}>
              <Typography variant="h4" gutterBottom className={classes.h4}>
                Here’s What You’ll Discover:
              </Typography>

              <Typography variant="body1" gutterBottom className={classes.body}>
                In this special recording, Geneen walks you through the process
                to uncover why we eat what doesn’t feel good in our bodies or
                choose foods that leave us lethargic or checked out.
              </Typography>
              <br />
              <Typography variant="body1" gutterBottom className={classes.body}>
                Join Geneen and connect the dots to discover the powerful next
                step to transforming your relationship with food.
              </Typography>
              <div className={classes.space}></div>
              <Typography
                variant="h6"
                gutterBottom
                className={classes.h6}
                style={{ fontWeight: 700 }}
              >
                By listening to this audio you will learn:
              </Typography>
              <Typography variant="body" gutterBottom className={classes.body}>
                <ul>
                  <li>
                    The positive and often unconscious reasons why we keep the
                    weight challenge alive
                  </li>
                  <li>
                    What we can do if we are fiercely attached and enamored with
                    sugar or overeating
                  </li>
                  <li>
                    How to use the pain we experience with food to push us
                    toward the life we long for
                  </li>
                  <li>
                    How to take a stand for the life our souls and true essence
                    desire
                  </li>
                </ul>
              </Typography>

              <Typography variant="body1" gutterBottom className={classes.body}>
                Ask yourself, what you really want. How you want to live. And
                then let this be the moment you finally make peace with food and
                discover what's possible when you reclaim your power.
              </Typography>
              <div className={classes.space}></div>
              <LeadForm />
            </Box>
            <Box
              p={1}
              mr={3}
              mt={5}
              width={"42%"}
              display={{ xs: "none", md: "block" }}
            >
              <img
                src={geneenPhoto}
                alt="Geneen Roth"
                className={classes.aboutImage}
                style={{ width: "100%" }}
              />
            </Box>
          </Box>

          <Box
            display="flex"
            p={1}
            m={1}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box p={1} mr={3} mt={5} width={{ xs: "100%", md: "42%" }}>
              <img
                src={geneenIllustration}
                alt="Geneen Roth"
                className={classes.aboutImage}
                style={{ width: "100%" }}
              />
            </Box>

            <Box p={1} width={{ xs: "100%", md: "58%" }}>
              <Typography variant="h4" gutterBottom className={classes.h4}>
                Created By Geneen Roth
              </Typography>

              <Typography variant="body1" gutterBottom className={classes.body}>
                Geneen Roth is the author of ten books, including the
                just-released <i>This Messy Magnificent Life</i> and{" "}
                <i>New York Times</i>&nbsp; bestsellers <i>When Food Is Love</i>
                , <i>Lost and Found</i>, and <i>Women Food and God</i>, as well
                as <i>The Craggy Hole in My Heart and the Cat Who Fixed It</i>.
                Over the past thirty years, she has worked with thousands of
                people in her groundbreaking workshops and retreats and has
                appeared on numerous national shows, including{" "}
                <i>
                  The Oprah Winfrey Show, 20/20, the Today show, Good Morning
                  America
                </i>
                , and&nbsp;
                <i>The View</i>. She lives in California with charms of
                hummingbirds; her husband Matt; and Izzy the fabulous,
                eating-disordered dog.
              </Typography>
              <div className={classes.space}></div>
              <Typography variant="body1" gutterBottom className={classes.body}>
                Geneen Roth's pioneering books were among the first to link
                compulsive eating and perpetual dieting with deeply personal and
                spiritual issues that go far beyond food, weight and body image.
                Rather than pushing away the "crazy" things we do, Geneen's work
                proceeds with the conviction that our actions and beliefs make
                exquisite sense, and that the way to transform our relationship
                with food, our body, and so much more in our life is to be open,
                curious and kind with ourselves -- instead of punishing,
                impatient and harsh.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Layout>
      <OfferFooter />
    </>
  )
}

export default IndexPage
